/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NationalAuthenticationInput } from '../models/NationalAuthenticationInput';
import type { UserDto } from '../models/UserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    public static setup(version: string): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/User/Setup',
            path: { version },
        });
    }

    public static listUsers(version: string): CancelablePromise<Array<UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/User',
            path: { version },
        });
    }

    public static activateUser(userId: number, version: string): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/User/{userId}/Activate',
            path: { userId, version },
        });
    }

    public static deactivateUser(userId: number, version: string): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/User/{userId}/Deactivate',
            path: { userId, version },
        });
    }

    /**
     * @param version 
     * @returns boolean OK
     * @throws ApiError
     */
    public static canAddUser(
version: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/User/CanAdd',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static performNationalAuthentication(
version: string,
requestBody?: NationalAuthenticationInput,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/User/Authentication/National',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
